import React, { lazy } from 'react'
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar"
import ScrollToTop from "./components/ScrollToTop"


const Home = lazy(async () => await import('./pages/Home'))
const CandidacySubmission = lazy(async () => await import('./pages/CandidacySubmission'))
const ElectionResults = lazy(async () => await import('./pages/ElectionResults'))
const Memorandum = lazy(async () => await import('./pages/Memorandum'))


const App = () => {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/candidacy-submission" component={CandidacySubmission} />
        <Route exact path="/results/:name" component={ElectionResults} />
        <Route exact path="/memorandums" component={Memorandum} />
      </Switch>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
